<template>
  <header class="tkd-header" :class="{ 'not-sticky': isTournamentPage }">
    <div class="header-inner">
      <router-link to="/user/profile" class="brand">
        <img src="/logo.jpg" alt="Taekwondo.com.ua" class="brand-logo">
        <span class="brand-text">
          <b>Секретарська система</b>
          <small>Taekwondo.com.ua · V {{ appVersion }}</small>
        </span>
      </router-link>

      <nav class="header-nav" :class="{ open: menuOpen }">
        <router-link v-for="link in links" :key="link.to" :to="link.to" class="nav-link">
          <span class="nav-icon"><tkd-icon :name="link.icon"/></span>{{ link.label }}
        </router-link>

        <div class="nav-mobile-footer">
          <div class="user-chip" v-if="user">
            <span class="user-avatar">
              <img v-if="avatarUrl && !avatarFailed" :src="avatarUrl" alt="" @error="avatarFailed = true">
              <span v-else>{{ initials }}</span>
            </span>
            <span class="user-name">{{ fullName }}</span>
          </div>
          <button type="button" class="logout-btn" @click="logout">Вийти</button>
        </div>
      </nav>

      <div class="header-right">
        <router-link to="/user/profile" class="user-chip" v-if="user" title="Мій профіль">
          <span class="user-avatar">
            <img v-if="avatarUrl && !avatarFailed" :src="avatarUrl" alt="" @error="avatarFailed = true">
            <span v-else>{{ initials }}</span>
          </span>
          <span class="user-name">{{ fullName }}</span>
        </router-link>
        <button type="button" class="logout-btn" @click="logout" title="Вийти">
          <span class="logout-icon"><tkd-icon name="logout"/></span><span class="logout-text">Вийти</span>
        </button>
      </div>

      <button
        type="button"
        class="burger"
        :class="{ open: menuOpen }"
        @click="menuOpen = !menuOpen"
        :aria-expanded="menuOpen ? 'true' : 'false'"
        aria-label="Меню"
      ><span></span><span></span><span></span></button>
    </div>
    <div class="header-flag"><span></span><span></span></div>
  </header>
</template>
<script>
  import 'src/assets/css/tkd-theme.css';
  import {baseUrlServer} from "../api/user";
  import {APP_VERSION} from 'src/utils/appUpdate';

  export default {
    data () {
      return {
        menuOpen: false,
        avatarFailed: false,
        links: [
          { to: '/user/profile', label: 'Профіль', icon: 'user' },
          { to: '/user/tournaments', label: 'Турніри', icon: 'trophy' },
        ]
      }
    },
    computed: {
      appVersion() {
        return APP_VERSION;
      },
      userOne() {
        return this.$store.getters['user/userOne'];
      },
      // на сторінці турніру закріплюються таби турніру, а не шапка
      isTournamentPage() {
        return this.$route.path.indexOf('/user/tournaments/overview') === 0;
      },
      user() {
        return this.userOne && this.userOne.data ? this.userOne.data.user : null;
      },
      avatarUrl() {
        return this.user && this.user.img ? baseUrlServer + this.user.img : '';
      },
      fullName() {
        let name = [this.user.fname, this.user.lname].filter(Boolean).join(' ');
        return name || this.user.username || 'Секретар';
      },
      initials() {
        let source = [this.user.fname, this.user.lname].filter(Boolean);
        if (!source.length && this.user.username) source = [this.user.username];
        return source.map(part => part.charAt(0).toUpperCase()).join('').slice(0, 2);
      }
    },
    watch: {
      $route() {
        this.menuOpen = false;
      },
      avatarUrl() {
        this.avatarFailed = false;
      }
    },
    methods: {
      logout(){
        localStorage.removeItem('jwt');
        this.$router.replace({ path: `/login` });
        return false;
      }
    }
  }

</script>
<style scoped>
  .tkd-header {
    position: sticky;
    top: 0;
    z-index: 1000;
    background: var(--tkd-gradient-hero);
    background-color: var(--tkd-navy);
    box-shadow: 0 8px 24px rgba(6, 16, 38, 0.25);
    font-family: var(--tkd-font);
    color: #fff;
  }

  .tkd-header.not-sticky { position: relative; }

  .header-inner {
    display: flex;
    align-items: center;
    gap: 28px;
    max-width: 1100px;
    height: 68px;
    margin: 0 auto;
    padding: 0 15px;
  }

  .brand {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
    color: #fff;
    text-decoration: none;
  }

  .brand:hover { color: #fff; text-decoration: none; }

  .brand-logo {
    width: 40px;
    height: 40px;
    border-radius: 11px;
    object-fit: cover;
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.15);
  }

  .brand-text { display: flex; flex-direction: column; line-height: 1.2; }
  .brand-text b { font-size: 16px; font-weight: 800; letter-spacing: -0.01em; }
  .brand-text small { font-size: 11px; color: rgba(255, 255, 255, 0.55); }

  /* Nav */
  .header-nav {
    display: flex;
    align-items: center;
    gap: 6px;
    flex: 1;
  }

  .nav-link {
    position: relative;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 9px 14px;
    border-radius: 10px;
    font-size: 15px;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.72);
    text-decoration: none;
    transition: color 0.15s, background 0.15s;
  }

  .nav-link:hover { color: #fff; background: rgba(255, 255, 255, 0.08); text-decoration: none; }

  .nav-link.router-link-active { color: #fff; background: rgba(255, 255, 255, 0.12); }

  .nav-link.router-link-active::after {
    content: '';
    position: absolute;
    left: 14px;
    right: 14px;
    bottom: -14px;
    height: 3px;
    border-radius: 3px 3px 0 0;
    background: var(--tkd-yellow);
  }

  .nav-icon { font-size: 15px; }
  .nav-mobile-footer { display: none; }

  /* Right side */
  .header-right {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
  }

  .user-chip {
    display: flex;
    align-items: center;
    gap: 10px;
    max-width: 240px;
    padding: 4px 14px 4px 4px;
    border-radius: 999px;
    color: #fff;
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.12);
    text-decoration: none;
    transition: background 0.15s;
  }

  a.user-chip:hover { color: #fff; background: rgba(255, 255, 255, 0.14); text-decoration: none; }

  .user-avatar {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 800;
    background: var(--tkd-gradient-btn);
  }

  .user-avatar img { width: 100%; height: 100%; object-fit: cover; }

  .user-name {
    font-size: 14px;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .logout-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    height: 40px;
    padding: 0 14px;
    border: 1px solid rgba(255, 255, 255, 0.18);
    border-radius: 10px;
    background: transparent;
    color: rgba(255, 255, 255, 0.85);
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s, border-color 0.15s, color 0.15s;
  }

  .logout-btn:hover { color: #fff; background: rgba(240, 68, 56, 0.2); border-color: rgba(240, 68, 56, 0.6); }
  .logout-btn:focus-visible,
  .nav-link:focus-visible,
  .user-chip:focus-visible,
  .burger:focus-visible { outline: 2px solid var(--tkd-yellow); outline-offset: 2px; }
  .logout-icon { font-size: 16px; }

  .header-flag {
    display: flex;
    height: 3px;
  }
  .header-flag span { flex: 1; background: var(--tkd-blue); }
  .header-flag span + span { background: var(--tkd-yellow); }

  /* Burger */
  .burger {
    display: none;
    flex-direction: column;
    justify-content: center;
    gap: 5px;
    width: 42px;
    height: 42px;
    margin-left: auto;
    padding: 0 10px;
    border: 1px solid rgba(255, 255, 255, 0.18);
    border-radius: 10px;
    background: transparent;
    cursor: pointer;
  }

  .burger span {
    display: block;
    height: 2px;
    border-radius: 2px;
    background: #fff;
    transition: transform 0.2s, opacity 0.2s;
  }

  .burger.open span:nth-child(1) { transform: translateY(7px) rotate(45deg); }
  .burger.open span:nth-child(2) { opacity: 0; }
  .burger.open span:nth-child(3) { transform: translateY(-7px) rotate(-45deg); }

  @media (max-width: 767px) {
    .header-inner { height: 60px; gap: 12px; }
    .brand-text small { display: none; }
    .header-right { display: none; }
    .burger { display: flex; }

    .header-nav {
      position: absolute;
      top: 100%;
      left: 0;
      right: 0;
      flex-direction: column;
      align-items: stretch;
      gap: 4px;
      padding: 12px 16px 16px;
      background: var(--tkd-navy);
      box-shadow: 0 16px 30px rgba(6, 16, 38, 0.35);
      opacity: 0;
      visibility: hidden;
      transform: translateY(-8px);
      transition: opacity 0.2s, transform 0.2s, visibility 0.2s;
    }

    .header-nav.open { opacity: 1; visibility: visible; transform: none; }
    .nav-link { padding: 12px 14px; }
    .nav-link.router-link-active::after { left: 0; right: auto; top: 10px; bottom: 10px; width: 3px; height: auto; border-radius: 0 3px 3px 0; }

    .nav-mobile-footer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      margin-top: 8px;
      padding-top: 12px;
      border-top: 1px solid rgba(255, 255, 255, 0.1);
    }

    .nav-mobile-footer .user-chip { min-width: 0; }
  }
</style>
